/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  '@atlassian/edition-awareness.button.addPaymentDetails': 'お支払い情報を追加',
  '@atlassian/edition-awareness.button.automation-limits-breached': '上限に達しました',
  '@atlassian/edition-awareness.button.automation-near-limit': '上限に近づいています',
  '@atlassian/edition-awareness.button.daysLeft': '{trialDaysLeft, plural, other {残り {trialDaysLeft,number} 日}}',
  '@atlassian/edition-awareness.button.education-offer': '教育機関向け割引',
  '@atlassian/edition-awareness.button.limited-users-left':
    '{product, select, jpd {残りの作成者枠に限りがあります} jsm {残りのエージェント枠に限りがあります} jira {残りのユーザー枠に限りがあります} confluence {残りのユーザー枠に限りがあります} other {残りのユーザー枠に限りがあります}}',
  '@atlassian/edition-awareness.button.limited-users-left-content-adjustment':
    '{product, select, jpd {作成者は残り 1 枠です} jsm {エージェントは残り 1 枠です} other {ユーザーは残り 1 枠です}}',
  '@atlassian/edition-awareness.button.no-users-left':
    '{product, select, jpd {作成者数の上限に達しました} jsm {エージェント数の上限に達しました} jira {ユーザー数の上限に達しました} confluence {ユーザー数の上限に達しました} other {ユーザー数の上限に達しました}}',
  '@atlassian/edition-awareness.button.no-users-left-content-adjustment':
    '{product, select, jpd {作成者数の上限に達しました} jsm {エージェント数の上限に達しました} other {ユーザー数の上限に達しました}}',
  '@atlassian/edition-awareness.button.premium-trial': 'Premium トライアル',
  '@atlassian/edition-awareness.button.see-plans': 'プランを確認できます',
  '@atlassian/edition-awareness.button.see-plans.cbrt': 'プランを確認できます',
  '@atlassian/edition-awareness.button.standard-trial': 'Standard トライアル',
  '@atlassian/edition-awareness.button.storage-hard-limit': 'ストレージがいっぱいです',
  '@atlassian/edition-awareness.button.upgrade': 'アップグレード',
  '@atlassian/edition-awareness.button.upgrade.standard-to-premium': 'アップグレード',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.approaching-limits.subtitle':
    '{automation_limit_runs_free, plural, other {自動化は、実行回数が毎月 {automation_limit_runs_free} 回に達すると停止します}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.approaching-limits.title':
    '{automation_limit_runs_free, plural, other {{automation_limit_runs_free} 回中 {automations_used} 回の自動化を実行しました}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.automations-breached-title':
    '自動化の実行回数が上限に達しました - アップグレードして実行回数を増やしましょう',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.breached-limits.breached-subtitle':
    '自動化は来月まで実行できません',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.breached-limits.title': '上限に達しました',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.dismiss': '閉じる',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.free-limit': 'Free プランの上限',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.free-limit-value':
    '{automation_limit_runs_free, plural, other {{automation_limit_runs_free,number} 回の実行}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-features.automation-benefits':
    '繰り返し作業を自動化して時間を節約',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-features.more-automations':
    'Standard プランなら、実行回数が {automation_runs_standard_comparison} 倍になります',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-features.unlimited-users':
    'ユーザー数無制限、セキュリティ強化など',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-limit': 'Standard プランの上限',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-limit-value':
    '{automation_limit_runs_standard, plural, other {{automation_limit_runs_standard,number} 回の実行}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.text.automation-limits-reset':
    '実行回数は毎月リセットされます。',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.text.automation-limits-reset-with-manage-automations':
    '実行回数は毎月リセットされます。<Link>自動化を管理</Link>',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.title':
    'アップグレードして、中断なしで引き続き自動化を実行しましょう',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.upgrade': 'アップグレード',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.add-payment-details': 'お支払い情報を追加',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.dismiss': '閉じる',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.free-limit': 'Free プランの上限',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.free-limit-value':
    '{automation_limit_runs_free, plural, other {{automation_limit_runs_free,number} 回の実行}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.modal-title':
    '支払い情報を追加して、引き続き自動化を実行しましょう',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-features.automation-benefits':
    '高度な管理者コントロールと管理者権限',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-features.more-automations':
    '{automation_limit_standard_comparison, plural, other {毎月の自動化の実行回数が {automation_limit_standard_comparison} 倍に}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-features.unlimited-users':
    'ユーザー数無制限、セキュリティ強化などを維持できます',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-limit': 'Standard プランの上限',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-limit-value':
    '{automation_limit_runs_standard, plural, other {{automation_limit_runs_standard,number} 回の実行}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.text.automation-limits-add-payment':
    'Free プランでは自動化を実行できる回数が少なくなります。{endDate,date,medium}にトライアルが終了するまで料金は請求されません。',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.text.automation-limits-add-payment-without-date':
    'Free プランでは自動化を実行できる回数が少なくなります。トライアルが終了するまで料金は請求されません。',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.text.automation-limits-list-features':
    'Standard プランの次の機能を維持しましょう',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.title':
    'Free プランでは実行回数が {automation_free_limit_percentage_comparison,number,::percent} 少なくなります',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.title-not-breached':
    'ダウングレードすると、実行回数が {automation_free_limit_percentage_comparison,number,::percent} 少なくなります',
  '@atlassian/edition-awareness.dialog.automation-limits-modal.approaching-limits.projection-title':
    '毎月 {projection} 回の自動化の利用が予測されています',
  '@atlassian/edition-awareness.dialog.automation-limits-modal.approaching-limits.title':
    'アップグレードを継続して、引き続き大規模な自動化を実行しましょう',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.apply-description':
    '今すぐお申し込みください。承認されると、選択したプランに割引が自動適用されます。次のような機能を利用できます。',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.apply-for-discount': '割引を申し込む',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.compare-plans': 'プランを比較',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.dont-show-again': '今後は表示しない',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.confluence.hub':
    'ニュース、最新情報、リソースの一元的なハブ',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.confluence.users':
    'コラボレーターを簡単に追加できる無制限のユーザー数',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.confluence.whiteboards':
    'グループで構想を練るのに適した無制限のホワイトボード',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jira.grammar': '文法と文章作成のアシスタント',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jira.security':
    '高度なセキュリティと利用状況のインサイト',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jira.users':
    'コラボレーターを簡単に追加できる無制限のユーザー数',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jpd.security':
    '高度なセキュリティと利用状況のインサイト',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jpd.users':
    'コラボレーターを簡単に追加できる無制限のユーザー数',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jpd.views':
    '今後の計画を共有できる読み取り専用ビュー',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jsm.agents':
    '日常的なリクエストに対応できる自動サービス エージェント',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jsm.security':
    '高度なセキュリティと利用状況のインサイト',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jsm.users':
    '最大 20,000 のヘルプ エージェント、無制限の顧客数',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.illustration.alt':
    '教師、学生、その他: 最大 75% 割引を申し込むことができます。',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.title': '教育機関向け割引を申し込む 📚',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.heading-at-limit':
    'これ以上無料ユーザーを追加できません',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.heading-get-everyone-in-one-tool':
    'すべてのユーザーが同じツールを使用できます',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.heading-near-limit':
    'アップグレードしてチームを追加しましょう',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.invited-users-count':
    '上限 {licensedUserLimit} 人のうち {numberOfUsers} 人を招待しました',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.maybe-later': '後で',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.subtitle-for-premium':
    '30 日間の Premium 無料トライアルを始めましょう。トライアルはいつでもキャンセルできます。トライアル期間が終了する 3 日前にリマインダーをお送りします。',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.subtitle-for-standard':
    '14 日間の Standard 無料トライアルを始めましょう。トライアルはいつでもキャンセルできます。トライアル期間が終了する 3 日前にリマインダーをお送りします。',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.try-it-now': '今すぐ試す',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.upgrade-for-gb-storage':
    '{gbToBuy} GB のストレージにアップグレードできます',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.upgrade-for-unlimited-storage':
    'アップグレードするとストレージが無制限になります',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.upgrade-for-unlimited-users':
    'アップグレードすると、ユーザーは無制限になります',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.user-limit-description-for-premium':
    '{licensedUserLimit, plural, other {{licensedUserLimit} 人を超えるユーザーを追加すると、自動的にアップグレードされます}}',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.user-limit-description-for-standard':
    '{licensedUserLimit, plural, other {{licensedUserLimit} 人を超えるユーザーを招待すると、Standard プランの 14 日間の無料トライアルが開始されます}}',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.continue': '後で',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.heading':
    'アップグレードすると、ユーザーは無制限になります',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.heading-at-limit':
    '上限に達したため、アップグレードをお勧めします',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.heading-near-limit':
    'アップグレードしてチーム全員を追加',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.standard-features.atlassian-support':
    'アトラシアンからのサポート',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.standard-features.data-security':
    'Free プランからさらに強化されたデータ セキュリティ',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.standard-features.more-automations':
    '追加の自動化とストレージ',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.standard-features.start-trial-description':
    '14 日間の Standard 無料トライアルを開始し、高度な機能をご利用ください。トライアルはいつでもキャンセルできます。次のような機能を利用できます。',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.standard-features.unlimited-users':
    'ユーザー数は無制限',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.upgrade': 'アップグレード',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.leftover-users-title':
    '{leftoverUsers, plural, other {無料ユーザーは残り {leftoverUsers} 枠}}',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.no-users-title':
    '無料ユーザーは残っていません',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.user-limits-auto-trial-description':
    '10 人を超えるユーザーを招待すると、トライアルが自動的に開始されます',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.user-limits-free-limit-description':
    'Free プランのユーザー数上限は 10 人です',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.user-limits-title':
    '{licensedUserLimit, plural, other {{licensedUserLimit} 人中 {numberOfUsers} 人の Free プランのユーザーが追加されました}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-limits.description':
    '{standardStorageLimit} GB のストレージにアップグレードできます',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-limits.title':
    '{storageLimit} GB 中 {storageUsed} GB が使用されています',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-limits.title.aria':
    '上限 {storageLimit} GB のうち {storageUsed} GB のストレージを使用しています',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-used.title':
    '{storageLimit} GB 中 {storageUsed} GB が使用されています',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-used.title.aria':
    '{storageLimit} GB 中 {storageUsed} GB が使用されています',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.user-limits.description':
    'アップグレードすると、ユーザーは無制限になります',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.user-limits.description.near-limit':
    '{licensedUserLimit, plural, other {{licensedUserLimit} 人を超えるユーザーを招待すると、Standard プランの 14 日間の無料トライアルが開始されます}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.user-limits.title':
    '上限 {licensedUserLimit} 人のうち {numberOfUsers} 人を招待しました',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.description':
    '14 日間の Standard 無料トライアルを始めましょう。トライアルはいつでもキャンセルできます。トライアル期間が終了する 3 日前にリマインダーをお送りします。',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.maybe-later': '後で',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.title-at-limit':
    'これ以上無料ユーザーを追加できません',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.title-near-limit':
    'アップグレードしてチームを追加しましょう',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.title-not-near-limit':
    'すべてのユーザーが同じツールを使用できます',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.try-now': '今すぐ試す',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.increased-storage.alt':
    'Jira に添付ファイルを追加している',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.increased-storage.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.increased-storage.title':
    'ストレージ上限の引き上げ',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.anonymous-access.description':
    'チーム外のユーザーに安全なアクセスを提供します。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.anonymous-access.title':
    '匿名アクセス',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.support.description':
    'アトラシアンの専門家チームによるサポートを受けられます。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.support.title':
    '営業時間内のサポート',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.title': 'Standard プランの機能',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.user-roles.description':
    '各プロジェクトやアクションに合わせて、ユーザーのアクセス権をより詳細に設定できます。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.user-roles.title':
    'ユーザーのロールと権限',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.storage-limits.description':
    '{standardStorageLimit} GB ストレージにアップグレードすると、引き続きファイルを添付できます',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.storage-limits.title':
    '上限 {storageLimit} GB のうち {storageUsed} GB のストレージを使用しています',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.storage-limits.title.aria':
    '上限 {storageLimit} GB のうち {storageUsed} GB のストレージを使用しています',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.unlimited-users.alt': 'Jira へのユーザーの追加',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.unlimited-users.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.unlimited-users.title': 'ユーザー数は無制限',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.user-limits.description':
    '{licensedUserLimit, plural, other {アップグレードすると、ユーザー数は無制限になります。{licensedUserLimit} 人を超えるユーザーを追加すると、自動的にアップグレードされます。}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.user-limits.title':
    '{licensedUserLimit, plural, other {上限 {licensedUserLimit} 人のうち {numberOfUsers} 人のユーザーを招待しました}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.continue': 'Free プランで続ける',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.description':
    '現在、Free プランをご利用中です。Standard プランの 14 日間無料トライアルをご利用ください。ユーザー数無制限で、追加ストレージなどをご利用いただけます。トライアルはいつでもキャンセルできます。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.title': 'Standard プランにアップグレード',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.try-now': '今すぐ試す',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.increased-storage.alt':
    'Jira Product Discovery に添付ファイルを添付する',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.increased-storage.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.increased-storage.title':
    'ストレージ上限の引き上げ',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.custom-roles.description':
    '特定の権限を持つカスタム プロジェクト ロールを作成すると、より詳細に状況を把握できます。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.custom-roles.title':
    'プロジェクト ロールのカスタマイズ',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.data-residency.description':
    'データをホストする場所を選択します。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.data-residency.title':
    'データ レジデンシー',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.support.description':
    'アトラシアンの専門家チームによるサポートを受けられます。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.support.title':
    '営業時間内のサポート',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.title': 'Standard の機能',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.storage-limits.description':
    '{standardStorageLimit} GB ストレージにアップグレードすると、引き続きファイルを添付できます',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.storage-limits.title':
    '上限 {storageLimit} GB のうち {storageUsed} GB のストレージを使用しています',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.storage-limits.title.aria':
    '上限 {storageLimit} GB のうち {storageUsed} GB のストレージを使用しています',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.unlimited-creators.alt':
    'Jira Product Discovery に作成者を追加する',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.unlimited-creators.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.unlimited-creators.title': '作成者数無制限',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.user-limits.description':
    '{licensedUserLimit, plural, other {アップグレードして作成者を無制限にしましょう。{licensedUserLimit} 人を超える作成者を追加すると、自動的にアップグレードされます。}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.user-limits.title':
    '{licensedUserLimit, plural, other {上限 {licensedUserLimit} 人のうち {numberOfUsers} 人の作成者を招待しました}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.continue': 'Free プランで続ける',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.description':
    '現在、Free プランをご利用中です。Standard プランの 14 日間無料トライアルをお試しください。無制限の作成者や追加ストレージなどをご利用いただけます。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.title': 'Standard プランにアップグレード',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.try-now': '今すぐ試す',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-description':
    'アップグレードすると、エージェントは無制限になります。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-button': 'エージェントとは何ですか?',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-description':
    'エージェントは Jira Service Management でカスタマー リクエストに対応します。カスタマー リクエストはすべてのユーザーが送信でき、Jira Service Management でリクエストを送信できるユーザーの数に制限はありません。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-heading':
    'Jira Service Management のエージェントとは何ですか?',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-link': 'エージェントの詳細',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-title':
    '{licensedUserLimit, plural, other {上限 {licensedUserLimit} 人のうち {numberOfUsers} 人のエージェントを招待しました}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.increased-storage.alt':
    '添付ファイルを追加している',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.increased-storage.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.increased-storage.title':
    'ストレージ上限の引き上げ',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.on-call-management.description':
    'カスタムのルーティング ルールとエスカレーション ポリシーを作成します。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.on-call-management.title':
    'オンコール管理',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.support.description':
    'アトラシアンの専門家チームによるサポートを受けられます。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.support.title':
    '営業時間内のサポート',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.title': 'Standard の機能',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.unlimited-email-notifications.description':
    'リクエストに応じて、アクティビティに関する最新情報を全員に通知します。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.unlimited-email-notifications.title':
    '無制限のメール通知',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.storage-limits.description':
    '{standardStorageLimit} GB ストレージにアップグレードすると、引き続きファイルを添付できます',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.storage-limits.title':
    '上限 {storageLimit} GB のうち {storageUsed} GB のストレージを使用しています',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.storage-limits.title.aria':
    '上限 {storageLimit} GB のうち {storageUsed} GB のストレージを使用しています',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.unlimited-creators.alt':
    'エージェントを追加している',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.unlimited-creators.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.unlimited-creators.title':
    'エージェント数は無制限',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.continue': 'Free プランで続ける',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.description':
    '現在、Free プランをご利用中です。Standard プランの 14 日間無料トライアルをお試しください。無制限のエージェントや追加ストレージなどをご利用いただけます。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.heading': 'Standard プランにアップグレード',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.try-now': '今すぐ試す',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.add-payment-details-button': 'お支払い情報を追加',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.premium-content':
    'トライアル終了後も Premium プランを継続するには、お支払い情報を追加してください。',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.premium-heading': 'Premium トライアル',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.standard-content':
    'トライアル終了後も Standard プランを継続するには、お支払い情報を追加してください。',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.standard-heading': 'Standard トライアル',
  '@atlassian/edition-awareness.dialog.premium-add-payment.add-payment': 'お支払い情報を追加',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.ai.description':
    'AI を使用した ITSM 機能で、優れたサービス エクスペリエンスを実現します。',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.ai.title':
    'Atlassian Intelligence (AI)',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.automation.description':
    '重大なインシデントの作成プロセスを自動化します。',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.automation.title':
    '高度なインシデント管理',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.support.description':
    'アトラシアンの専門家チームによる 24 時間年中無休のサポートを受けられます。',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.support.title': 'Premium サポート',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.title':
    'Premium には次の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.premium-add-payment.continue': '今は変更しない',
  '@atlassian/edition-awareness.dialog.premium-add-payment.subtitle':
    'Premium 機能をキャンセルせずに引き続き使用するには、トライアル期間の終了前に支払い情報を追加してください。',
  '@atlassian/edition-awareness.dialog.premium-add-payment.title':
    '{trialDaysLeft, plural, other {Premium プランのトライアルは {trialDaysLeft,number} 日後に終了します}}',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.add-payment-details-link':
    'お支払い情報を追加して Premium プランを継続',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.after-trial':
    'トライアル終了後、Free プランにダウングレードされます。',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.end-trial-and-change-plans-link':
    'トライアルを終了してプランを変更',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.explore-premium-features-link': 'Premium の機能を見る',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.heading': '30 日間の Premium トライアル',
  '@atlassian/edition-awareness.dialog.standard-add-payment.add-payment': 'お支払い情報を追加',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-insights.alt':
    'Confluence のページ インサイトの画面',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-insights.title':
    'コンテンツ インサイト',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-restrictions.alt':
    'Confluence のページ制限の画面',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-restrictions.title':
    'コンテンツ制限',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.guest-access.alt':
    'Confluence のゲスト アクセスの画面',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.guest-access.title': 'ゲスト アクセス',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.unlimited-users.alt':
    'Confluence インスタンスにユーザーを追加している',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.unlimited-users.title':
    'ユーザー制限は無制限',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.add-payment':
    'Standard プランの利用を続けるには、支払い情報を追加してください。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.alt': '添付ファイルの追加',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.exceeded-free':
    'Free プランのストレージ上限 ({freeStorageLimit} GB) を超過しました。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.heading':
    'Standard プランを継続すると、拡張されたストレージを引き続き利用できます',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.standard-includes.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.standards-limit':
    'Standard プランのストレージ上限は {storageLimit} GB です。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.title':
    'ストレージ上限の引き上げ',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.usage':
    '<strong>{storageUsed} GB</strong> のストレージを使用しています',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.custom-roles.description':
    'カスタムのルーティング ルールとエスカレーション ポリシーを作成します。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.email-notifications.description':
    'リクエストに応じて、アクティビティに関する最新情報を全員に通知します。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.email-notifications.title':
    '無制限のメール通知',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.on-call-management.title':
    'オンコール管理',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.support.description':
    'アトラシアンの専門家チームによるサポートを受けられます。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.support.title':
    '営業時間内のサポート',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.title': 'Standard の機能',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.storage-limit-bar.aria':
    '{storageLimit} GB 中 {storageUsed} GB が使用されています',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-creators.jpd.heading':
    '{userCount, plural, other {<span>{userCount,number} 人の作成者</span>を招待しました。Free プランの作成者数は最大 3 人です。}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users-image.alt': 'ユーザーの追加',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users-image.heading':
    'Standard には以下の高度な機能が含まれています。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users-image.title':
    '{product, select, jpd {作成者数は無制限} jsm {エージェント数は無制限} jira {ユーザー数は無制限} confluence {ユーザー数は無制限} other {ユーザー数は無制限}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.heading':
    '{product, select, jpd {Standard プランを継続し、作成者数を無制限のままにする} jsm {Standard プランを継続し、エージェント数を無制限のままにする} jira {Standard プランを継続するとユーザー数は引き続き無制限です} confluence {Standard プランを継続するとユーザー数は引き続き無制限です} other {Standard プランを継続するとユーザー数は引き続き無制限です}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm-popup':
    'エージェントは Jira Service Management でカスタマー リクエストに対応します。カスタマー リクエストはすべてのユーザーが送信でき、Jira Service Management でリクエストを送信できるユーザーの数に制限はありません。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm-popup-link':
    'エージェントの詳細',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm-popup-what-are-agents':
    'Jira Service Management のエージェントとは何ですか?',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm.heading':
    '{userCount, plural, other {<span>{userCount,number} 人のエージェント</span>を招待しました。Free プランのエージェント数の上限は 3 人です。<link>エージェントとは何ですか?</link>}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.title':
    '{product, select, jpd {作成者数は無制限} jsm {エージェント数は無制限} jira {ユーザー数は無制限} confluence {ユーザー数は無制限} other {ユーザー数は無制限}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.continue': 'このままトライアルを続ける',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.custom-roles.description':
    '特定の権限を持つカスタム プロジェクト ロールを作成すると、より詳細に状況を把握できます。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.custom-roles.title':
    'プロジェクト ロールのカスタマイズ',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.data-residency.description':
    'データをホストする場所を選択します。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.data-residency.title':
    'データ レジデンシー',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.support.description':
    'アトラシアンの専門家チームによるサポートを受けられます。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.support.title':
    '営業時間内のサポート',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.storage-limits.description':
    'Free プランの上限を {dataUsageOverFreeLimitInGB} GB 超えています',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.storage-limits.title':
    '{storageLimit} GB 中 {storageUsed} GB が使用されています',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.storage-limits.title.aria':
    '上限 {storageLimit} GB のうち {storageUsed} GB のストレージを使用しています',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.description':
    'チーム メイトや関係者をコラボレーションに招待しましょう',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.description.near-limit':
    '{userLimitOverFreeLimit, plural, other {あなたのチームは Free プランのユーザー数の上限を {userLimitOverFreeLimit} 人超えています}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.title':
    'ユーザー数無制限の特典をご活用ください',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.title.near-limit':
    'ユーザー数無制限の特典を利用しています',
  '@atlassian/edition-awareness.dialog.standard-add-payment.subtitle':
    'Standard の機能をキャンセルせずに引き続き使用するには、トライアル期間の終了前に支払い情報を追加してください。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.subtitle-trial-days-left':
    '{trialDaysLeft, plural, other {トライアル終了後も Standard 機能の使用を続けるには、支払い情報を追加してください。トライアルは {trialDaysLeft} 日後に終了します。}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.title':
    '{trialDaysLeft, plural, other {Standard プランのトライアルは {trialDaysLeft,number} 日後に終了します}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.title-take-action': '引き続き高度な機能を利用するには',
  '@atlassian/edition-awareness.dialog.standard-to-premium.compare-features.cta': 'プランと価格を比較する',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.jira.text': '24 時間年中無休のサポート',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.jira.tooltip':
    '必要に応じて、アトラシアンのエキスパートからサポートを受けられます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.name': '24 時間年中無休のサポート',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.text': '24 時間年中無休のサポート',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.tooltip':
    'いつでもアトラシアンから必要なサポートを受けられます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.value':
    'いつでもアトラシアンから必要なサポートを受けられます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.jira.text': '管理者インサイト',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.jira.tooltip':
    'ユーザー アクティビティ、製品の利用状況、セキュリティを追跡できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.name': '管理者インサイト',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.text': '管理者インサイト',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.tooltip':
    'ユーザー アクティビティ、製品の利用状況、セキュリティを追跡できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.value':
    'ユーザー アクティビティ、製品の利用状況、セキュリティを追跡できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.advanced-alerts.text': '高度なアラート',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.advanced-alerts.tooltip':
    'インシデントの迅速な解決に役立つアラートを受け取れます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.ai.text': 'Atlassian Intelligence',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.ai.tooltip':
    'ページの要約や文章の作成の支援などを指示できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.name': 'アナリティクス',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.text': 'アナリティクス',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.tooltip':
    'ページに対するユーザーの反応に関するデータを取得できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.value':
    'ページに対するユーザーの反応に関するデータを取得できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.name': 'アセット管理',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.text': 'アセット管理',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.tooltip':
    '会社のインベントリを保存、マッピング、監査します',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.value':
    '会社のインベントリを保存、マッピング、監査します',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.name':
    'Atlassian intelligence',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.text':
    'Atlassian intelligence',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.tooltip':
    'AI を使用してリスクの発見、タスクの自動化、編集を行います',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.value':
    'AI を使用してリスクの発見、タスクの自動化、編集を行います',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.company-hub.text': '会社ハブ',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.company-hub.tooltip':
    '会社のあらゆる情報の信頼できる唯一の情報源を構築できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.name': 'チーム横断プランニング',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.text': 'チーム横断プランニング',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.tooltip':
    'すべてのプロジェクトとタイムラインを 1 か所で確認できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.value':
    'すべてのプロジェクトとタイムラインを 1 か所で確認できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.deployment-gating.text': 'デプロイ ゲートの構成',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.deployment-gating.tooltip':
    'リスクのある変更を自動制御によって回避できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.incident-management.text': 'インシデント管理',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.incident-management.tooltip':
    '問題の特定、課題の追跡、エスカレーションを行えます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.name': 'ミッション コントロール',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.text': 'ミッション コントロール',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.tooltip':
    '権限の管理とインサイトの取得を 1 か所で行えます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.value':
    '権限の管理とインサイトの取得を 1 か所で行えます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.project-archiving.text': 'プロジェクトのアーカイブ',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.project-archiving.tooltip':
    '非アクティブの作業をアーカイブして作業を整理できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.real-time-incident-monitoring.text':
    'リアルタイムのインシデント モニタリング',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.real-time-incident-monitoring.tooltip':
    'インシデントが発生したときに追跡して管理できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.release-tracks.text': 'リリース トラック',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.release-tracks.tooltip':
    '変更をリリースするタイミングと方法を制御できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.sandbox.text': 'サンドボックス',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.sandbox.tooltip':
    '製品化する前に安全なテストと実験を実施できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.name': 'チーム カレンダー',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.text': 'チーム カレンダー',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.tooltip':
    'チームの垣根を超えて締め切りと休暇を計画しましょう',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.value':
    'チームの垣根を超えて締め切りと休暇を計画しましょう',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.name':
    '仮想サービス エージェント',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.text':
    '仮想サービス エージェント',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.tooltip':
    '人工知能を搭載したエージェントを使用して一般的な問題を処理できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.value':
    '人工知能を搭載したエージェントを使用して一般的な問題を処理できます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.whiteboards.text': '無制限のホワイトボード',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.whiteboards.tooltip':
    '無限のキャンバスでブレーンストーミングやフローの作成を行えます',
  '@atlassian/edition-awareness.dialog.standard-to-premium.heading': '高度な機能を利用しませんか? Premium を試す',
  '@atlassian/edition-awareness.dialog.standard-to-premium.highlighted-features.header.text':
    'これらの機能を無料でお試しください',
  '@atlassian/edition-awareness.dialog.standard-to-premium.highlighted-features.premium-label.text': 'Premium',
  '@atlassian/edition-awareness.dialog.standard-to-premium.subtitle':
    '30 日間無料トライアルを開始して、Premium の主な機能をお試しください。トライアルが終了する 3 日前にリマインダーが届きます。トライアルはいつでもキャンセルできます。',
  '@atlassian/edition-awareness.dialog.standard-to-premium.try-now.cta': '続行',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.add-payment-details': 'お支払い情報を追加',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.heading': 'Free プランの上限を超えています',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.maybe-later': '後で',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.base-limit.title':
    'Free プランの上限 ({freeStorageLimit} GB)',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.confluence.description':
    'Free プランでは、新しいページを追加することはできません。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.jira.description':
    'Free プランの上限を超えているため、新しいファイルを追加することはできません。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.title':
    '{storageUsed} GB のストレージを使用しています',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.default':
    'ダウングレードまたは無効化を回避するには、今すぐ支払い情報を追加してください。トライアルが終了するまで料金は発生しません。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.inPredunning.storageLimitBreaker':
    'ダウングレードを回避するには、お支払い情報を追加してください。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.inPredunning.userLimitBreaker':
    '非アクティブ化を回避するには、お支払い情報を追加してください。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.storageLimitBreakerForConfluence':
    '引き続きスペースとページを作成するには、今すぐ支払い情報を追加してください。{trialEndDate} にトライアルが終了するまで、料金は発生しません。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.storageLimitBreakerForJira':
    '引き続きファイルと画像をアップロードするには、今すぐ支払い情報を追加してください。{trialEndDate} にトライアルが終了するまで、料金は発生しません。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.userAndStorageLimitBreaker':
    'ダウングレードまたは無効化を回避するには、今すぐ支払い情報を追加してください。{trialEndDate} にトライアルが終了するまで、料金は発生しません。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.userLimitBreaker':
    '無効化を回避するには、支払い情報を追加してください。{trialEndDate} にトライアルが終了するまで、料金は発生しません。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.description.over-limit':
    '{userLimit, plural, other {Free プランで維持できるユーザー数は {userLimit} 人までです。}}',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.description.under-limit':
    'チーム メイトや関係者をコラボレーションに招待しましょう',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.divider-limit-label':
    'Free プランの上限 ({userLimit} 人)',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.title.over-limit':
    '{licensedUsers, plural, other {{licensedUsers} 人のユーザーが招待されました}}',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.title.under-limit':
    'ユーザー数無制限の特典をご活用ください',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.breached-limits.subtitle':
    'アップグレードするまでチームは添付ファイルを追加できません',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.breached-limits.title': 'ストレージ上限を超えました',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.description-for-jira-admin':
    'アップグレードしてストレージを増やすか、<Link>添付ファイルを削除</Link>してださい。',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.description-for-non-admin':
    'ストレージを増やすには、管理者に連絡してアップグレードしてください。',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.dismiss': '閉じる',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.feature.more-files':
    'ドキュメント、ファイル、画像を制限なしでアップロード',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.feature.more-storage':
    'Standard プランなら、チームのストレージが 125 倍に',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.feature.more-users':
    'ユーザー数無制限、セキュリティ強化など',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.free-limit': 'Free プランの上限',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.free-limit-value': '2 GB',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.standard-limit': 'Standard プランの上限',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.standard-limit-value': '250 GB',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.title':
    'チームの無料ストレージの上限に達しました。ストレージを増やすにはアップグレードしてください',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.upgrade': 'アップグレード',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.premium.description':
    'Premium の強力な機能をご覧ください。',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.premium.title': 'Premium トライアル開始',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.standard.description':
    'Standard のパワフルな機能をお試しください。',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.standard.title': 'Standard トライアル開始',
  '@atlassian/edition-awareness.dialog.timeline.trial-current-day.premium.description':
    'Premium がチームにとって最適かどうかを判断してください。',
  '@atlassian/edition-awareness.dialog.timeline.trial-current-day.standard.description':
    'Standard がチームにとって最適か判断してください。',
  '@atlassian/edition-awareness.dialog.timeline.trial-current-day.title':
    '{trialDaysLeft, plural, other {今日: トライアルが {trialDaysLeft,number} 日後に終了}}',
  '@atlassian/edition-awareness.dialog.timeline.trial-ends.premium.description':
    'この日までに、Premium プランを継続するか Free プランにダウングレードする操作を実行してください。',
  '@atlassian/edition-awareness.dialog.timeline.trial-ends.standard.description':
    'この日までに、Standard プランを継続するか Free プランにダウングレードする操作を実行してください。',
  '@atlassian/edition-awareness.dialog.timeline.trial-ends.title': 'トライアル終了',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.data-privacy.link':
    'アトラシアンのデータ プライバシーに関する詳細',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-1': 'チームの規模',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-2': 'すでにご利用のアトラシアン製品',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.why-am-i-seeing-this':
    'チームの生産性の向上には、{offering} がお勧めです。次のような理由から、請求管理者にのみこのお勧めを表示しています。',
  '@atlassian/edition-awareness.link.add-payment-tooltip': 'お支払い情報を追加して、サブスクリプションを継続します',
  '@atlassian/edition-awareness.link.jira-standard-trial-overview-tooltip': 'トライアルとお支払い方法に関する詳細',
  '@atlassian/edition-awareness.spotlight.message':
    'アップグレードする準備ができていない場合、準備が整ったらプロファイルに戻ってください。',
  'trial-components.action.menu.downgrade.message.v2': 'トライアル終了後、Free プランにダウングレードされます。',
  'trial-components.add.payment.premium.button': 'お支払い情報を追加して Premium プランを継続',
  'trial-components.end.trial.button': 'トライアルを終了してプランを変更',
  'trial-components.explore.premium.button': 'Premium の機能を見る',
  'trial-components.premium.charge-message':
    '{trialEndDate} にトライアルが終了すると、Premium の月額コストの請求が開始されます。',
  'trial-components.premium.feature-highlight-description.toggle': 'ラベルで Premium 機能が見つけやすくなります。',
  'trial-components.premium.feature-highlight-title.toggle': 'Premium の機能を強調する',
  'trial-components.premium.review-feature-guide.button': '機能ガイドを確認',
  'trial-components.premium.trial.title': 'Premium トライアル',
  'trial-components.see.billing.button': '請求先情報を表示',
};
